
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.714 11.071a9.185 9.185 0 004.252 4.233.863.863 0 00.853-.064l2.726-1.818a.87.87 0 01.826-.076l5.1 2.186a.868.868 0 01.523.903A5.228 5.228 0 0115.809 21 14.809 14.809 0 011 6.191a5.228 5.228 0 014.565-5.185.868.868 0 01.903.523l2.188 5.104a.871.871 0 01-.072.82l-1.811 2.768a.863.863 0 00-.059.85v0z","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    